import { ApiError } from '@/lib/api'
import { fehlersatz } from '@/lib/fehlersatz'
import { uebersetze } from '@/lib/uebersetzen'

/**
 * Was beim Hochladen oder Löschen einer Datei schiefging, als Satz in der
 * Sprache des Lesers.
 *
 * Der Server schickt zu jedem Fehler einen Code (`error`), bei einigen dazu
 * einen deutschen Satz für Entwickler (`message`). Bis zum 08.10.2026 zeigten
 * Bild- und PDF-Feld diesen Satz an: Ein englischer Kundenzugang las „Nur JPG,
 * PNG, GIF oder WebP erlaubt." Jetzt zählt der Code. Was hier nicht steht,
 * geht an `fehlersatz()`, das auch technische Pannen in einen Satz fasst.
 */
export function dateifehler(e: unknown): string {
  const body = e instanceof ApiError
    ? (e.body as { error?: unknown; max_bytes?: unknown; stellen?: unknown } | null)
    : null
  switch (body?.error) {
    case 'unsupported_image':
      return uebersetze('datei.fehler.kein_bild')
    case 'not_a_pdf':
      return uebersetze('datei.nur_pdf')
    case 'not_a_video':
      return uebersetze('video.nur_mp4')
    case 'file_too_large':
      return typeof body.max_bytes === 'number'
        ? uebersetze('datei.fehler.zu_gross', { mb: Math.floor(body.max_bytes / 1024 / 1024) })
        : uebersetze('datei.fehler.zu_gross_kurz')
    case 'upload_error':
      return uebersetze('datei.fehler.abgebrochen')
    case 'r2_not_configured':
      return uebersetze('datei.fehler.nicht_eingerichtet')
    case 'process_failed':
      return uebersetze('datei.fehler.verarbeitung')
    case 'upload_failed':
      return uebersetze('datei.fehler.speicher')
    case 'kein_dokument':
      return uebersetze('datei.fehler.kein_dokument')
    case 'fremdes_dokument':
      return uebersetze('datei.fehler.fremdes_dokument')
    case 'loeschen_fehlgeschlagen':
      return uebersetze('datei.fehler.loeschen')
    case 'noch_in_gebrauch': {
      /* Der Server sagt, WO sie noch steht. Ohne diese Liste stuende der
         Benutzer vor einem Nein ohne Grund. */
      const stellen = Array.isArray(body.stellen) && body.stellen.length > 0
        ? ` (${body.stellen.join(', ')})`
        : ''
      return uebersetze('datei.noch_in_gebrauch') + stellen
    }
  }
  return fehlersatz(e, uebersetze('datei.was'))
}
